import { BrowserRouter, Routes, Route, useNavigationType, Navigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { useEffect } from 'react';

// pages & components
import AboutPage from "./pages/AboutPage";
import AlbumPage from "./pages/Album/AlbumPage";
import ArtistAlbumsPage from "./pages/Artist/ArtistAlbumsPage";
import ArtistCreditsIconPage from "./pages/Artist/ArtistCreditsIconPage";
import ArtistCreditsPage from "./pages/Artist/ArtistCreditsPage";
import ArtistDiscoveryListPage from "./pages/ArtistDiscoveryListPage";
import ArtistDiscoveryPage from "./pages/ArtistDiscoveryPage";
import ArtistPage from "./pages/Artist/ArtistPage";
import ArtistSongsPage from "./pages/Artist/ArtistSongsPage";
import FeedbackPage from "./pages/FeedbackPage";
import Home from "./pages/Home/Home";
import LoginPage from "./pages/Login/LoginPage";
import Navbar from "./components/Navbar/Navbar";
import PageNotFoundPage from "./pages/PageNotFoundPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import ProfilePage from "./pages/Profile/ProfilePage";
import CreatePlaylistPage from "./pages/Playlist/CreatePlaylistPage";
import ViewPlaylistPage from "./pages/Playlist/ViewPlaylistPage";
import PlaylistsFeedPage from "./pages/Playlist/PlaylistsFeedPage";
import RecentReleases from "./pages/RecentReleases/RecentReleases";
import ReviewPage from "./pages/Review/ReviewPage";
import SearchResultsPage from "./pages/SearchResults";
import SongPage from "./pages/Song/SongPage";
import TopCreditsPage from "./pages/TopCreditsPage";
import Footer from "./Footer/Footer";
import RecentReleasesList from "./pages/RecentReleases/RecentReleasesList";
import ScrollToTop from "./components/ScrollToTop";
import { preventScrollRestoration } from "./utils/scrollHelper";

// App Router wrapper
function AppRoutes() {
  // Prevent default scroll restoration behavior
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    // Force scroll to top on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <div className="pages">
        <Routes>
          <Route
            path="/artist/:artist/credits-featured"
            element={<ArtistCreditsIconPage />}
          />
          <Route
            path="/artist/:artist/credits-written"
            element={<ArtistCreditsIconPage />}
          />
          <Route
            path="/artist/:artist/credits-composed"
            element={<ArtistCreditsIconPage />}
          />
          <Route
            path="/artist/:artist/credits-arranged"
            element={<ArtistCreditsIconPage />}
          />
          <Route
            path="/artist/:artist/credits"
            element={<ArtistCreditsPage />}
          />
          <Route path="/artist/:artist/songs" element={<ArtistSongsPage />} />
          <Route
            path="/artist/:artist/albums"
            element={<ArtistAlbumsPage />}
          />

          <Route path="/artist/:artist" element={<ArtistPage />} />
          <Route path="/song/:song" element={<SongPage />} />
          <Route path="/album/:album" element={<AlbumPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/top-credits" element={<TopCreditsPage />} />
          <Route
            path="/artist-discovery/:type"
            element={<ArtistDiscoveryPage />}
          />
          <Route
            path="/artist-discovery-list"
            element={<ArtistDiscoveryListPage />}
          />
          <Route path="/search" element={<SearchResultsPage />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/create-playlist" element={<CreatePlaylistPage />} />
          <Route path="/playlist/:playlistId" element={<ViewPlaylistPage />} />
          <Route path="/review/:reviewId" element={<ReviewPage />} />
          <Route path="/feed" element={<PlaylistsFeedPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/recent-releases" element={<RecentReleases />} />
          <Route path="/recent-releases-list" element={<RecentReleasesList />} />
          <Route path="/" element={<Home />} />
          <Route path="*" element={<PageNotFoundPage msg={undefined} />} />
        </Routes>
        <Footer />
      </div>
    </>
  );
}

function App() {
  // Initialize scroll restoration prevention once at app load
  useEffect(() => {
    preventScrollRestoration();
  }, []);

  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <AppRoutes />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
